const MAX_HOURS = 23;
const MAX_TIME_PERIOD_HOURS = 12;
const MIN_HOURS = 0;
const MIN_TIME_PERIOD_HOURS = 1;
const MAX_MINUTES = 59;
const MIN_MINUTES = 0;
const AM_TIME = 'AM';
const PM_TIME = 'PM';
const BEFORE = 'before';
const AFTER = 'after';
const HOURS_REGEXP_12 = '^(0?[1-9]?|1[0-2])$';
const HOURS_REGEXP_24 = '^([0-1]?[0-9]|2[0-3])$';
const MINUTES_REGEXP = '^([0-5]?[0-9])$';
const FULL_TIME_REGEX_24_WITH_SECONDS = '^(-?[0-1]?[0-9]|2[0-3]):([0-5]?[0-9]):([0-5]?[0-9])$';
const FULL_TIME_REGEX_24 = '^([0-1]?[0-9]|2[0-3]):([0-5]?[0-9])$';
const FULL_TIME_REGEX_MERIDIUM = '^(1[0-2]|0?[1-9]):([0-5]?[0-9]) ?([AaPp][Mm])$';
const VALID_24_HOURS_VALUE_LENGTH = 8;
const VALID_24_HOURS_DISPLAY_VALUE_LENGTH = 5;
const VALID_12_HOURS_DISPLAY_VALUE_LENGTH = 8;
const ARROW_UP_KEY = 'ArrowUp';
const ARROW_DOWN_KEY = 'ArrowDown';
const ENTER_KEY = 'Enter';
const TIME_FORMAT_24_HOURS = 'HH:mm';
const TIME_FORMAT_12_HOURS = 'hh:mm a';
const HELPER_TEXT_MERIDIEM = 'hh:mm (a|p)m';
const HELPER_TEXT_24_HOURS = 'hh:mm';
const defaultLabels = {
  main: 'Time picker',
  hours: 'Hours',
  minutes: 'Minutes',
  before: 'Before',
  after: 'After',
  cancel: 'Cancel',
  apply: 'Apply',
  invalidTimeFormat: 'Invalid time format'
};

export { AFTER, AM_TIME, ARROW_DOWN_KEY, ARROW_UP_KEY, BEFORE, ENTER_KEY, FULL_TIME_REGEX_24, FULL_TIME_REGEX_24_WITH_SECONDS, FULL_TIME_REGEX_MERIDIUM, HELPER_TEXT_24_HOURS, HELPER_TEXT_MERIDIEM, HOURS_REGEXP_12, HOURS_REGEXP_24, MAX_HOURS, MAX_MINUTES, MAX_TIME_PERIOD_HOURS, MINUTES_REGEXP, MIN_HOURS, MIN_MINUTES, MIN_TIME_PERIOD_HOURS, PM_TIME, TIME_FORMAT_12_HOURS, TIME_FORMAT_24_HOURS, VALID_12_HOURS_DISPLAY_VALUE_LENGTH, VALID_24_HOURS_DISPLAY_VALUE_LENGTH, VALID_24_HOURS_VALUE_LENGTH, defaultLabels };
